/**
 * Field validity for renewal step 1 (Digital PAF / prescriber screen).
 */
export function validatePrescriberScreen1(fields, allCheckedPrescriber) {
  const {
    indication = "",
    indication_other = "",
    molecule = "",
    clinical_trial = "",
  } = fields;

  return {
    indication_other: {
      isValid: !indication?.label?.includes("Other")
        ? true
        : indication_other && Boolean(indication_other?.trim())
          ? true
          : false,
    },
    clinical_trial: {
      isValid: !indication?.label?.includes("Clinical")
        ? true
        : Boolean(clinical_trial?.trim())
          ? true
          : false,
    },
    molecule: {
      isValid: molecule?.label?.trim().length >= 0,
    },
    confirmation_risk_prescriber: {
      isValid: !!allCheckedPrescriber,
    },
  };
}
